/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Footer_LineInputs */

const en_hotel_footer_line = /** @type {(inputs: Hotel_Footer_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI rap music videos and short videos, made from your photos.`)
};

/**
* | output |
* | --- |
* | "AI rap music videos and short videos, made from your photos." |
*
* @param {Hotel_Footer_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_footer_line = /** @type {((inputs?: Hotel_Footer_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Footer_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_footer_line(inputs)
});
export { hotel_footer_line as "hotel.footer.line" }